import { useRequest } from 'ahooks'
import AgsCard from '../agsCard/index'
import styles from './index.module.less'
import { getAgsPledgeList } from '@/api/account'
import { useEffect, useState } from 'react'
import type { IResAgsPledgeListItem } from '@/api/account/interface.ts'
import LoadingCom from '@/components/LoadingCom'
import MeEmpty from '@/components/MeEmpty'
interface IProps {
  address: string
  activeValue: string | undefined
  pageParams: {
    page: number
    limit: number
  }
  setAgsTotal: (total: number) => void
  setAgsLoading: (loading: boolean) => void
}
const AgsList = ({ address, activeValue, pageParams, setAgsTotal, setAgsLoading }: IProps) => {
  const listParams = {
    address,
    page_number: pageParams.page,
    page_size: pageParams.limit,
  }
  const [agsList, setAgsList] = useState<IResAgsPledgeListItem[]>([])
  const { loading, run } = useRequest(() => getAgsPledgeList(listParams), {
    manual: true,
    onSuccess: (res) => {
      setAgsList(res?.agsDelegation || [])
      setAgsTotal(res?.total || 0)
    },
  })

  useEffect(() => {
    run()
  }, [pageParams, run, address])

  useEffect(() => {
    setAgsLoading(loading)
  }, [loading, setAgsLoading])

  return (
    <>
      {activeValue === '0' && (
        <div className={styles.wrap}>
          {loading && <LoadingCom />}
          {!loading && agsList.length === 0 && <MeEmpty />}
          {agsList.map((item, index) => (
            <AgsCard {...item} key={`agsList${index}`} />
          ))}
        </div>
      )}
    </>
  )
}

export default AgsList
